<template>
	<el-main class="info-wrap">
		<div class="info-box">
			<div>
				<div class="info-head tc">
					<h3 class="info-title">量大信息研究院（平台运营）</h3>
				</div>
				<div class="info-content" v-html="infoText"></div>
			</div>
		</div>
	</el-main>
</template>

<script>
	export default {
		data() {
			return {
				infoText: `<h2>量大（北京）信息科技研究院</h2><h3><strong>让专业知识进入 AI，让行业经验真正可用</strong></h3><p>量大（北京）信息科技研究院有限公司是一家专注于垂直行业 AI 应用的科技企业，长期聚焦“知识工程 + 人工智能”在高专业门槛行业中的落地实践。</p><p>我们相信，真正有价值的行业 AI，不只是“能聊天”，而是能够理解专业语境、连接权威资料、给出可核验依据，并在真实业务场景中帮助用户提高效率、降低风险、沉淀知识。</p><p>围绕这一目标，量大以法律法规、技术规范、标准文件、专业图书和企业内部资料为核心知识资产，构建从数据治理、结构化加工、知识库建设、智能检索、模型适配到业务智能体应用的一体化能力，服务政府部门、检验检测机构、行业组织、制造企业及工程技术人员，推动专业知识的数字化、智能化和可持续使用。</p><h3><strong>我们是谁</strong></h3><p>量大是一家面向强规范行业的 AI 知识服务公司。</p><p>在特种设备、工业制造、检验检测、标准法规、企业合规等领域，大量关键工作都依赖法规标准、技术文件和专业经验。传统模式下，资料分散、版本复杂、查找耗时、依据难以核验，既影响工作效率，也带来合规风险。</p><p>量大的工作，就是把这些复杂的专业资料转化为 AI 能理解、能检索、能引用、能服务业务的知识基础设施，让行业用户能够更快找到依据、更准确理解要求、更可靠完成判断。</p><h3><strong>我们在做什么</strong></h3><p>量大围绕垂直行业知识服务，重点建设三类能力：</p><ol><li><strong>高质量行业知识库</strong></li><p>我们将法律、法规、规章、安全技术规范、国家标准、行业标准、技术图书、企业制度文件、项目资料等专业文档进行系统化整理和结构化加工，形成可检索、可引用、可追溯的专业知识库。</p><p>不同于简单上传 PDF 后进行问答，量大更重视数据质量和知识结构。我们会对文件目录、章节、条款、表格、公式、图示、引用关系、替代关系、效力状态等要素进行处理，使知识不再停留在“文件堆”中，而是成为可被 AI 调用和业务系统使用的结构化资源。</p><li><strong>面向行业场景的 AI 应用</strong></li><p>我们将大语言模型与行业知识库、业务规则和专业流程相结合，开发面向真实工作场景的 AI 应用，包括法规标准问答、条款检索、文件审查、合规核验、许可评审辅助、培训学习、企业资料管理和知识智能体等。</p><p>我们的目标不是让 AI 替代专业人员做最终判断，而是帮助专业人员更快获得依据、更全面理解要求、更高效完成资料准备和技术分析。</p><li><strong>企业知识管理与智能化升级</strong></li><p>对于企业客户，量大帮助其将内部制度、技术文件、项目资料、培训材料、评审资料等沉淀为可管理、可授权、可检索、可问答的企业知识资产。</p><p>通过知识库、书单、权限管理和 AI 问答的结合，企业可以把分散在部门、岗位和个人电脑中的资料统一组织起来，让经验得以复用，让知识进入流程，让 AI 真正服务企业日常工作。</p></ol><h3><strong>我们的核心产品：特规通</strong></h3><p>“特规通”是量大面向特种设备行业打造的法规标准与 AI 知识服务平台，也是我们知识工程能力在垂直行业中的重要产品化成果。</p><p>特规通围绕特种设备行业“查法规、用标准、管资料、问 AI、备评审、做培训”的高频需求，提供法规标准库、AI-行业大模型、企业资料馆、正版图书购买等核心功能，帮助特种设备从业单位和工程技术人员更高效地使用专业资料。</p><p>在特规通中，用户不仅可以查询正版合规、持续更新的法规标准资源，还可以将企业内部资料接入 AI，通过书单限定检索范围，使问答结果更加聚焦、准确和可核验。对于企业用户，特规通进一步支持正版资料管理、企业知识库建设、子账号授权、许可评审资料准备和合规审核应用，帮助企业把法规标准和内部知识转化为可持续使用的专业能力。</p><h3><strong>我们的技术理念</strong></h3><p>量大坚持“数据质量优先、专业依据优先、业务场景优先”。</p><p>在强规范行业中，AI 的风险往往不在于“不会说”，而在于“说得像真的但没有依据”。因此，我们始终强调：</p><ul><li><strong>来源可信</strong>：优先使用官方、正版、权威和可核验的数据来源；</li><li><strong>结构清晰</strong>：将复杂文档加工为可检索、可定位、可引用的知识单元；</li><li><strong>回答可查</strong>：AI 输出应尽可能回到原文、条款、表格、公式和文件依据；</li><li><strong>边界明确</strong>：对于缺少条件或存在适用范围差异的问题，提示用户补充信息或核验边界；</li><li><strong>持续更新</strong>：关注法规标准、企业资料和业务规则的变化，让知识库保持有效；</li><li><strong>人机协同</strong>：AI 辅助专业人员提升效率，而不是替代专业判断和责任边界。</li></ul><p>我们希望把 AI 做成专业人员真正愿意用、企业真正敢用、场景真正能用的行业工具。</p><h3><strong>我们的优势</strong></h3><p>量大的优势来自对专业知识、工程数据和行业场景的长期理解。</p><p>我们既关注大模型、RAG、知识图谱、文档解析、智能体等 AI 技术，也重视法规标准体系、许可评审逻辑、质量管理要求和工程技术人员的实际工作习惯。</p><p>这使我们能够在垂直行业中解决一些通用 AI 产品难以解决的问题：</p><ul><li>如何保证资料来源清晰、版本准确、状态有效；</li><li>如何让 AI 回答落到具体法规标准和条款依据；</li><li>如何在复杂标准体系中进行跨文件检索和关联分析；</li><li>如何把企业内部资料变成可管理、可授权、可问答的知识库；</li><li>如何让 AI 服务许可评审、合规审核、培训学习和日常工程判断；</li><li>如何在效率提升的同时保持专业严谨性和可追溯性。</li></ul><h3><strong>我们服务的客户</strong></h3><p>量大服务的客户包括政府部门、行业组织、检验检测机构、特种设备生产和使用单位、工业制造企业、科研院所、培训机构及专业工程技术人员。</p><p>我们的产品和服务可用于法规标准查询、企业知识库建设、许可评审准备、质量体系管理、内部培训、技术审查、资料归档、智能问答和业务流程智能化等场景。</p><h3><strong>我们的愿景</strong></h3><p>量大的愿景，是成为垂直行业可信赖的 AI 知识基础设施提供者。</p><p>我们希望通过知识工程和人工智能技术，把专业知识从分散文件、个人经验和低效检索中释放出来，让法规标准更容易查询，让企业资料更容易管理，让行业经验更容易沉淀，让 AI 真正成为专业人员身边可靠、高效、可核验的工作助手。</p><p>未来，量大将继续深耕特种设备及更多强规范行业，持续建设高质量行业知识库、专业 AI 模型和智能体应用，帮助行业用户在合规、安全和效率之间实现更好的平衡。</p>`
			};
		}
	};
</script>

<style lang="less" scoped>
	.info-wrap {
		margin-left: 20px;
		padding: 20px 0 !important;
		font-size: 14px;
		color: #475569;
		line-height: 1.8;
		background-color: #fff;
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
		border-radius: 12px;
		min-height: calc(100vh - 120px);

		.info-title {
			margin: 0 0 10px;
			font-weight: 600;
			font-size: 24px;
			color: #334155;
		}
	}

	.info-item {
		margin-bottom: 20px;
	}

	.info-head {
		margin-bottom: 25px;
		padding-bottom: 15px;
		border-bottom: 1px dashed #e2e8f0;

		.topbox {
			color: #94a3b8;

			dd {
				margin: 0 30px 0 0;
			}
		}
	}
</style>

<style lang="less">
	.info-content {
		padding: 0 30px;
	}

	.info-content h2 {
		margin: -4px 0 0 !important;
	}

	.info-content ul {
		li {
			line-height: 30px !important;
		}
	}

	.info-content p {
		margin-top: 6px !important;
		margin-bottom: 6px !important;
		line-height: 24px !important;
	}

	.info-content h3 {
		margin: 16px 0 6px !important;
	}

	.info-content h5 {
		color: #0f172a;
		font-size: 16px;
		margin: 0;
		padding: 0;
		line-height: 34px;
		margin-top: 10px;
	}

	.info-content h6 {
		color: #0f172a;
		font-size: 16px;
		margin: 0;
		padding: 0;
		line-height: 34px;
		position: relative;
	}

	.info-content h6:before {
		content: ' ';
		display: inline-block;
		width: 5px;
		height: 5px;
		background: #155dfc;
		border-radius: 50%;
		margin-right: 10px;
		position: absolute;
		top: 16px;
		left: 18px;
	}

	.info-box {
		padding-bottom: 30px;
	}
	.info-content li::marker {
		color: #1456f0;
	}
</style>
